import { PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import {
  LayoutProvider,
  LoadersProvider,
  MenusProvider,
  SettingsProvider,
  SnackbarProvider,
  TranslationProvider,
} from "@/providers";
import { HelmetProvider } from "react-helmet-async";
import { persistor, store } from "@/store/store";
import { StatusAnnouncer } from "@/components/StatusAnnouncer";

const queryClient = new QueryClient();

const ProvidersWrapper = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider>
        {/* WCAG 4.1.3: Singleton live-region for programmatic status announcements */}
        <StatusAnnouncer />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <SettingsProvider>
              <TranslationProvider>
                <HelmetProvider>
                  <LayoutProvider>
                    <LoadersProvider>
                      <MenusProvider>{children}</MenusProvider>
                    </LoadersProvider>
                  </LayoutProvider>
                </HelmetProvider>
              </TranslationProvider>
            </SettingsProvider>
          </PersistGate>
        </Provider>
      </SnackbarProvider>{" "}
    </QueryClientProvider>
  );
};

export { ProvidersWrapper };
